export default "/static/media/noir.d8a06f88.css";